export default __webpack_public_path__ + "static/media/iconC.fc430729.png";